module.exports = __webpack_public_path__ + "static/media/nft-card-ecryptogirl.520b7702.png";